'use client'

import React from 'react'
import { useProductContext } from '@context/ProductContext/ProductContext'
import styles from './accordion.module.scss'

const CheckBoxInputField = ({ type, index, item }) => {
  const { setAccordianItem } = useProductContext()

  const handleToggle = () => {
    const updatedAccordianItem = item
    setAccordianItem(updatedAccordianItem)
  }

  return (
    <input
      type={type}
      role="button"
      id={`accordion-item-${type}-${item?.id}`}
      name={`accordionToggle-${type}`}
      className={styles.toggleInput}
      onClick={handleToggle}
      defaultChecked={index === 0 && type === 'radio'}
    />
  )
}

export default CheckBoxInputField
